import ServicePageTemplate from '../ServicePageTemplate';
import { homeFaqs } from '../../../mocks/faqs';

export default function PoolDeck() {
  return (
    <ServicePageTemplate
      heroTitle="Pool Deck Paver Installation"
      heroSubtitle="Create a beautiful, slip-resistant pool deck that handles Florida's heat, humidity, and poolside activity with ease."
      heroImage="https://www.parksidepavers.com/files/projects/15/thumb/thumb_Albano%2Dlanai%2Dlanding%2Ejpg"
      serviceBreakdownTitle="Our Pool Deck Services"
      serviceBreakdown={[
        { title: 'Slip-Resistant Surfaces', desc: 'Textured paver finishes that provide safe traction around wet pool environments.', icon: 'ri-water-flash-line' },
        { title: 'Heat-Reflective Pavers', desc: 'Light-colored paver options that stay cooler underfoot on hot Florida days.', icon: 'ri-sun-line' },
        { title: 'Custom Pool Surround Design', desc: 'Fully custom layouts that wrap seamlessly around any pool shape or size.', icon: 'ri-home-4-line' },
        { title: 'Drainage Solutions', desc: 'Proper grading and drainage built into every pool deck installation.', icon: 'ri-drop-line' },
      ]}
      aiAnswerText="Pool deck paver installation creates a durable, visually appealing surface around your pool that outperforms traditional concrete decking. Pavers offer better heat resistance, slip resistance, and drainage than poured concrete or stamped concrete. If a paver is damaged, it can be individually replaced without disturbing the entire surface. Parkside Pavers designs and installs custom pool deck paving solutions throughout Tampa Bay."
      aiAnswerBenefits={[
        'Slip-resistant for safety',
        'Stays cooler than concrete',
        'Resists pool chemical damage',
        'Easy individual paver replacement',
        'Custom shapes & patterns',
        'Proper drainage built in',
      ]}
      faqs={[
        { question: 'Are pavers safe for pool decks?', answer: 'Yes — pavers are one of the safest pool deck surface options available. Textured paver finishes provide excellent slip resistance even when wet, and their natural porosity improves drainage compared to smooth concrete surfaces.' },
        { question: 'Do pool deck pavers get too hot in Florida?', answer: 'Light-colored concrete and natural stone pavers reflect heat much better than dark surfaces. Parkside Pavers helps you select paver colors and materials that stay comfortable underfoot even on the hottest Florida days.' },
        ...homeFaqs.slice(3),
      ]}
      seoCity="Tampa Bay"
    />
  );
}
